import { Component, EventEmitter, OnInit, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { forkJoin } from 'rxjs';
import { PgTitleComponent } from 'src/app/shared/components/title-bar/title-bar.component';
import { Vessel, VesselOffHire, VesselsService } from '../../vessels.service';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { DateTimeHelpers } from 'src/app/shared/helpers/date-time.helpers';
import { Router } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AgGridService } from 'src/app/shared/ag-grid/ag-grid.service';

@Component({
  selector: 'app-vessels-off-hires',
  templateUrl: './vessels-off-hires.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule, AgGridModule]
})
export class VesselsOffHiresComponent implements OnInit, PgTitleComponent {
  title = new EventEmitter<string>();

  constructor(
    private _vesselService: VesselsService,
    private _organisationService: OrganisationService,
    private _router: Router,
    private _renderer:Renderer2,
  ) {}

  offHires: VesselOffHire[] = [];
  vessels: Vessel[] = [];
  organisations: Organisation[] = [];

  offHireStatus: Record<string, string> = {
    potential: 'Potential',
    claimed: 'Claimed',
    accepted: 'Accepted'
  };

  offHireTypes: Record<string, string> = {
    dryDock: 'Dry Dock',
    breakDown: 'Break Down',
  };

  gridOptions: GridOptions = {};

  columnDefs = [
    { headerName: '',
      cellRenderer: (params: { data: any; }) => AgGridService.editButton(
        this._renderer,
        this._router,
        (_router, data) => this.editRecord(data),
        params.data
      )
    },

    { headerName: 'IMO', field: 'vesselImo'},

    { headerName: 'Name',
      cellRenderer: (params: { vesselImo: string; }) => this.vesselFormatter(params.vesselImo)
    },

    { headerName: 'Type', field:'offHireType'},

    { headerName: 'From',
      cellRenderer: (params: { offHire: { from: { locationId: string; }; }; }) =>  this.organisationFormatter(params.offHire.from.locationId)
    },

    { headerName: 'From Date', field:'offHire.from.time' },

    { headerName: 'To',
      cellRenderer: (params: { offHire: { to: { locationId: string; }; }; }) => this.organisationFormatter(params.offHire.to.locationId)
    },

    { headerName: 'Diff',
      cellRenderer: (params: { offHire: { from: { time: string; }; to: { time: string; }; }; }) => this.offHiresDays(params.offHire.from.time, params.offHire.to.time)
    },

    { headerName: 'Amount', field:'usd'},
  ];

  ngOnInit() {
    this.title.emit('Vessels Off Hires');
    this.gridOptions = AgGridService.getOptions();
    forkJoin([
      this._vesselService.getOffHires(),
      this._vesselService.getActiveVessels(),
      this._organisationService.get()
    ]).subscribe(results => {
      this.offHires = results[0];
      this.vessels = results[1];
      this.organisations = results[2];
    });
  }

  gridSetting(event: GridReadyEvent) {
    AgGridService.setting(event);
  }

  vesselFormatter(imo: string) {
    return this.vessels.find(v => v.imo === imo)!.name!.name;
  }

  organisationFormatter(id: string) {
    return this.organisations.find(o => o.name === id)!.nameTranslations['en'];
  }

  offHiresDays(firstDate: string, secondDate: string) {
    return DateTimeHelpers.getTimeDiffFromDateStrings(firstDate, secondDate);
  }

  editRecord(offHire: VesselOffHire) {
    this._router.navigate(['vessels/off-hire', offHire.id]);
  }

}
